import { render, staticRenderFns } from "./joiner_product_detail.vue?vue&type=template&id=59143e12&scoped=true&"
import script from "./joiner_product_detail.vue?vue&type=script&lang=js&"
export * from "./joiner_product_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59143e12",
  null
  
)

export default component.exports